import { createSlice } from "@reduxjs/toolkit";

import ObservabilityPipelineHttpClient from "Api/observability/pipeline/client";

import { loadObservabilityPipelineConfiguration } from "./thunks";
import { ObservabilityPipelineState } from "./types";

const initialState: ObservabilityPipelineState = {
  clients: {},
  clientsLoadingState: {}
};

const observabilityPipelineReducer = createSlice({
  name: "observabilityPipeline",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadObservabilityPipelineConfiguration.pending,
      (state, action) => {
        if (!action.meta) {
          return;
        }

        state.clientsLoadingState[
          `${action.meta.arg.projectId}/${action.meta.arg.environmentId}`
        ] = "loading";
      }
    );
    builder.addCase(
      loadObservabilityPipelineConfiguration.rejected,
      (state, action) => {
        if (!action.payload) {
          return;
        }

        state.clientsLoadingState[
          `${action.meta.arg.projectId}/${action.meta.arg.environmentId}`
        ] = "failure";
      }
    );
    builder.addCase(
      loadObservabilityPipelineConfiguration.fulfilled,
      (state, action) => {
        if (!action.payload) {
          return;
        }

        const client = new ObservabilityPipelineHttpClient(
          action.meta.arg.projectId,
          action.meta.arg.environmentId,
          action.payload
        );
        state.clients[
          `${action.meta.arg.projectId}/${action.meta.arg.environmentId}`
        ] = client;
        state.clientsLoadingState[
          `${action.meta.arg.projectId}/${action.meta.arg.environmentId}`
        ] = "loaded";
      }
    );
  }
});

export default observabilityPipelineReducer.reducer;
